export default __webpack_public_path__ + "static/0262-d44d0be4d11191db48b556464636e47e.png";